/* eslint-disable */
export default [
  {
  "name": "Lamassu",
  "address": "20121 Industrial Ave #105",
  "city": "Langley",
  "state": "BC",
  "zip_code": "V3A 4K6",
  "country": "Canada",
  "lat": "49.10973373939153",
  "lng": "-122.66586493069057",
  "phone_number": "6045303246",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/lamassu/",
  "id":"6206de166b0be60b96c942f0"
  },
  {
    "name": "Grizzly Trucks",
    "address": "15685 Fraser Hwy",
    "city": "Surrey",
    "state": "BC",
    "zip_code": "V4N 0Y6",
    "country": "Canada",
    "lat": "49.161347",
    "lng": "-122.787768",
    "phone_number": "6045930662",
    "fax_number": null,
    "website": "http://www.mechaniclick.com/grizzlysurrey/",
    "id":"619d60ac3ddfde0bc5120f14"
    },
  {
  "name": "BC Tires & Auto Repair",
  "address": "8971 120 St",
  "city": "Delta",
  "state": "BC",
  "zip_code": "V4C 6R6",
  "country": "Canada",
  "lat": "49.16624867922086",
  "lng": "-122.89069255631469",
  "phone_number": "6045917396",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/bctdelta/",
  "id":"61145f681a9c240b8820e26e"
  },
  {
  "name": "Premier Tires and Wheels",
  "address": "8468 162 St Unit 104",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V4N 1B4",
  "country": "Canada",
  "lat": "49.156751",
  "lng": "-122.772907",
  "phone_number": "7788739429",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/premiertires/",
  "id":"5f59010c2ad0e70b855a4302"
  },
  {
  "name": "Budget Brake & Muffler - Surrey",
  "address": "13718 104 Ave",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3T 1W4",
  "country": "Canada",
  "lat": "49.191444",
  "lng": "-122.842286",
  "phone_number": "6045888588",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetsurrey/",
  "id":"5f49515a2ad0e70b855a42ec"
  },
  {
  "name": "Action Tire",
  "address": "10894 120 St,",
  "city": " Surrey",
  "state": "BC",
  "zip_code": "V3V 4G9",
  "country": "Canada",
  "lat": "49.200580",
  "lng": "-122.880452",
  "phone_number": "6045801766",
  "fax_number": null,
  "website": "http://www.ezfixd.com/",
  "id":"63ea781d9c1acd0ba4fde506"
  },
  {
    "name": "North Shore Off-Road Centre",
    "address": "19257 Enterprise Way #9",
    "city": "Surrey",
    "state": "BC",
    "zip_code": "V3S 6J8",
    "country": "Canada",
    "lat": "49.108385",
    "lng": "-122.689364",
    "phone_number": "6045344366",
    "fax_number": null,
    "website": "http://www.mechaniclick.com/grizzlysurrey/",
    "id":"6594684d33f14055e47bf510"
    },
  {
  "name": "R/T Tires",
  "address": "Unit #2 13550 77 Avenue",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 6Y3",
  "country": "Canada",
  "lat": "49.191444",
  "lng": "-122.842286",
  "phone_number": "6045350262",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/rt/",
  "id":"63d0482e5688420a84c84f59"
  },
  {
  "name": "BC Diesel",
  "address": "14620 64 Ave 114",
  "city": " Surrey",
  "state": "BC",
  "zip_code": "V3S 1X7",
  "country": "Canada",
  "lat": "49.117760",
  "lng": "-122.817383",
  "phone_number": "6045801766",
  "fax_number": null,
  "website": "http://www.ezfixd.com/",
  "id":"63eacdd09c1acd0ba4fde50c"
  },
  {
    "name": "Evolution Auto Performance",
    "address": "20170 Stewart Crescent #470",
    "city": "Maple Ridge",
    "state": "BC",
    "zip_code": "V2X 0T4",
    "country": "Canada",
    "lat": "49.212560",
    "lng": "-122.660247",
    "phone_number": "6044607969",
    "website": "http://www.ezfixd.com/",
    "fax_number": null,
    "id":"64e64fbb6575d728c85ee39d"
    },
    {
      "name": "Downes Automotive",
      "address": "20110 Stewart Crescent #11",
      "city": "Maple Ridge",
      "state": "BC",
      "zip_code": "V2X 0T4",
      "country": "Canada",
      "lat": "49.212560",
      "lng": "-122.660247",
      "phone_number": "6044659940",
      "website": "http://www.ezfixd.com/",
      "fax_number": null,
      "id":"652b04479af53e4d7ecce3eb"
      },
  {
  "name": "Midas Auto Services (Richmond)",
  "address": "4660 No.3 Road",
  "city": "Richmond",
  "state": "BC",
  "zip_code": "V6X 2C2",
  "country": "Canada",
  "lat": "49.179949366036624",
  "lng": "-123.1359531605215",
  "phone_number": "6043328959",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/midasrichmond/",
  "id":"6142cdde1a9c240b8820e2a8"
  },
  {
  "name": "Reaper Customs",
  "address": "31002 Peardonville Rd #401",
  "city": "Abbotsford",
  "state": "BC",
  "zip_code": "V2T 6W8",
  "country": "Canada",
  "lat": "49.045813",
  "lng": "-122.364091",
  "phone_number": "7785515567",
  "website": "http://www.mechaniclick.com/mnv/",
  "fax_number": null,
  "id":"648268dd00664e0bb181bb7d"
  },
  {
  "name": "Pro-Tech Auto Repair - Burnaby",
  "address": "5508 Imperial St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 1E7",
  "country": "Canada",
  "lat": "49.221718",
  "lng": "-122.984653",
  "phone_number": "6044306375",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/protech/",
  "id":"5f77a42f3b3286595e6cab6d"
  },
  {
  "name": "Pro-Tech Auto Repair - Surrey",
  "address": "7945 132 St Suite 103",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 4N2",
  "country": "Canada",
  "lat": "49.14688506887058",
  "lng": "-122.85735580909898",
  "phone_number": "6045912525",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/protech/",
  "id":"5f77a42f3b3286595e6cab6d"
  },
  {
  "name": "Surrey Centre Auto - Big-O-Tires",
  "address": "13654 104 Ave",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3T 1W2",
  "country": "Canada",
  "lat": "49.191326",
  "lng": "-122.843954",
  "phone_number": "6045881266",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/surreycentral/",
  "id":"5f4828c0c33f5b0b59ef9297"
  },
  {
  "name": "Vancouver Motor Sports",
  "address": "16 - 12772 82nd Ave.",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 3G1",
  "country": "Canada",
  "lat": "49.15062885717657",
  "lng": "-122.86919067165766",
  "phone_number": "6045909250",
  "website": "http://www.mechaniclick.com/vms/",
  "fax_number": null,
  "id":"61033293e910207feb02a834"
  },
  {
  "name": "Surrey Wheels & Tire Ltd. - Motorworld",
  "address": "8250 124 St",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 3X9",
  "country": "Canada",
  "lat": "49.153437128102794",
  "lng": "-122.87870590234225",
  "phone_number": "6045626737",
  "website": "http://www.mechaniclick.com/swts/",
  "fax_number": null,
  "id":"61033d7ae910207feb02a837"
  },
  {
  "name": "NAPA AUTOPRO - Drive-In Auto Repair",
  "address": "1027 Royal Ave",
  "city": "New Westminster",
  "state": "BC",
  "zip_code": "V3M 1K3",
  "country": "Canada",
  "lat": "49.20140486671082",
  "lng": "-122.91909204294485",
  "phone_number": "6045151148",
  "website": "http://www.mechaniclick.com/drivein/",
  "fax_number": null,
  "id":"614384071a9c240b8820e2b1"
  },
  {
  "name": "Stire - Safari Auto Tires Ltd.",
  "address": "1025 Quebec St.",
  "city": "New Westminster",
  "state": "BC",
  "zip_code": "V3M 1K6",
  "country": "Canada",
  "lat": "49.201793277494325",
  "lng": "-122.91931871410854",
  "phone_number": "6045444040",
  "website": "http://www.mechaniclick.com/stire/",
  "fax_number": null,
  "id":"6142eb921a9c240b8820e2ae"
  },
  {
  "name": "All Make Auto Repairs Centre",
  "address": "7835 132 st",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 4M8",
  "country": "Canada",
  "lat": "49.14543851538978",
  "lng": "-122.85711346060225",
  "phone_number": "6045976666",
  "website": "http://www.mechaniclick.com/allmake/",
  "fax_number": null,
  "id":"6104923de910207feb02a83e"
  },
  {
  "name": "The Garage - Napa Autopro",
  "address": "5707 Beresford St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 1J6",
  "country": "Canada",
  "lat": "49.21896908449569",
  "lng": "-122.98081579999997",
  "phone_number": "6047331312",
  "website": "http://www.mechaniclick.com/thegarage/",
  "fax_number": null,
  "id":"6025c0ae8954b86a2a099283"
  },
  {
  "name": "Mighty - Tune and Brake",
  "address": "2-6734 King George Blvd",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 4Z5",
  "country": "Canada",
  "lat": "49.125058879314466",
  "lng": "-122.84518264490579",
  "phone_number": "7786829644",
  "website": "http://www.mechaniclick.com/mighty/",
  "fax_number": null,
  "id":"6143945d1a9c240b8820e2b4"
  },
  {
  "name": "Napa Autopro - Newton",
  "address": "13573 72 Ave",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 2N9",
  "country": "Canada",
  "lat": "49.134016",
  "lng": "-122.846375",
  "phone_number": "6045967685",
  "website": "http://www.mechaniclick.com/napanewton/",
  "fax_number": null,
  "id":"5f99da1a0084470b7b370729"
  },
  {
  "name": "Budget Brake & Muffler - Surrey - Newton",
  "address": "101-13555 72 Avenue",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 2N9",
  "country": "Canada",
  "lat": "49.133847284671624",
  "lng": "-122.84727763558092",
  "phone_number": "6045922655",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetnewton/",
  "id":"5ff4b03849fde30b9695fcbe"
  },
  {
  "name": "Budget Brake & Muffler - Kingsway",
  "address": "6256 Kingsway",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 1H6",
  "country": "Canada",
  "lat": "49.219720986974",
  "lng": "-122.97237600175852",
  "phone_number": "6044390248",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetkingsway/",
  "id":"604fd2a39129490b6e4b2b45"
  },
  {
  "name": "Budget Brake & Muffler - Nanaimo",
  "address": "3575 Shenton Road",
  "city": "Nanaimo",
  "state": "BC",
  "zip_code": "V9T 2H1",
  "country": "Canada",
  "lat": "49.204306098369614",
  "lng": "-124.00845608465926",
  "phone_number": "2507588991",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetnanaimo/",
  "id":"5ffd084a49fde30b9695fcc4"
  },
  {
  "name": "Budget Brake and Muffler - Walnut Grove – Port Kells",
  "address": "19889 96 Ave 8",
  "city": "Langley",
  "state": "BC",
  "zip_code": "V1M 3C7",
  "country": "Canada",
  "lat": "49.177455",
  "lng": "-122.671080",
  "phone_number": "6048823771",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetwalnutgrove/",
  "id":"5f8a113a5447d70b72005c62"
  },
  {
  "name": "Budget Brake and Muffler - Coquitlam-Port Moody",
  "address": "2561 Barnet Highway",
  "city": "Coquitlam",
  "state": "BC",
  "zip_code": "V3H 1W4",
  "country": "Canada",
  "lat": "49.27842698789957",
  "lng": "-122.81963191534075",
  "phone_number": "6044642331",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetcoquitlam/",
  "id":"5ff8d04149fde30b9695fcc1"
  },
  {
  "name": "Budget Brake and Muffler - Langley",
  "address": "5923 200th Street",
  "city": "Langley",
  "state": "BC",
  "zip_code": "V3A 1N2",
  "country": "Canada",
  "lat": "49.1099712320029",
  "lng": "-122.66914454232878",
  "phone_number": "6045305371",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetlangley/",
  "id":"5ffddf4849fde30b9695fcc7"
  },
  {
  "name": "Budget Brake and Muffler - North Vancouver",
  "address": "1315 Cotton Road",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7J 1C2",
  "country": "Canada",
  "lat": "49.30685791525687",
  "lng": "-123.04032445767125",
  "phone_number": "6049808517",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetnorthvan/",
  "id":"5ffde2cc49fde30b9695fcca"
  },
  {
  "name": "Budget Brake and Muffler - Prince George",
  "address": "1795 Victoria Street",
  "city": "Prince George",
  "state": "BC",
  "zip_code": "V2L 2L6",
  "country": "Canada",
  "lat": "53.90753792152003",
  "lng": "-122.75579737301373",
  "phone_number": "2505632022",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetpg/",
  "id":"5ffde8cb49fde30b9695fccd"
  },
  {
  "name": "Budget Brake and Muffler - West Kelowna - Westbank",
  "address": "2406 Dobbin Rd",
  "city": "West Kelowna",
  "state": "BC",
  "zip_code": "V4T 2H9",
  "country": "Canada",
  "lat": "49.82900420865363",
  "lng": "-119.62579145767124",
  "phone_number": "2507680330",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetwkw/",
  "id":"5ffded5549fde30b9695fcd0"
  },
  {
  "name": "Budget Brake and Muffler - Maple Ridge",
  "address": "22750 Lougheed Hwy",
  "city": "Maple Ridge",
  "state": "BC",
  "zip_code": "V2X 2V6",
  "country": "Canada",
  "lat": "49.21629404881253",
  "lng": "-122.59228900000001",
  "phone_number": "6044637158",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/budgetmapleridge/",
  "id":"5fff2b7c49fde30b9695fcd3"
  },
  {
  "name": "Optimum Auto Service",
  "address": "8416 118 Ave NW",
  "city": "Edmonton",
  "state": "AB",
  "zip_code": "T5B 0S5",
  "country": "Canada",
  "lat": "53.57063711335996",
  "lng": "-113.47046545767039",
  "phone_number": "7804772883",
  "website": "http://www.mechaniclick.com/optimum/",
  "fax_number": null,
  "id":"6035819a843cd90b4b142c4a"
  },
  {
  "name": "PDR - Diesel Performance",
  "address": "307 - 20630 Mufford Crescent",
  "city": "Langley",
  "state": "BC",
  "zip_code": "V2Y 2V9",
  "country": "Canada",
  "lat": "49.116474001490886",
  "lng": "-122.65096700234372",
  "phone_number": "8445303092",
  "website": "http://www.mechaniclick.com/pdr/",
  "fax_number": null,
  "id":"60ec77fbe910207feb02a825"
  },
  {
  "name": "Euro Class Motors",
  "address": "101A-20785 Langley Bypass",
  "city": "Langley",
  "state": "BC",
  "zip_code": "V3A 5E8",
  "country": "Canada",
  "lat": "49.11398699823239",
  "lng": "-122.64709683487769",
  "phone_number": "6045349422",
  "website": "http://www.mechaniclick.com/euroclass/",
  "fax_number": null,
  "id":"60ec81a9e910207feb02a828"
  },
  {
  "name": "Minit-Tune - Crowfoot",
  "address": "152 Crowfoot Gate NW",
  "city": "Calgary",
  "state": "AB",
  "zip_code": "T3G 3L1",
  "country": "Canada",
  "lat": "51.12793399761993",
  "lng": "-114.19692856156996",
  "phone_number": "4032398772",
  "website": "http://www.mechaniclick.com/minitcrowfoot/",
  "fax_number": null,
  "id":"6038109d843cd90b4b142c4d"
  },
  {
  "name": "Mechanigo",
  "address": "3656 61 Ave SE",
  "city": "Calgary",
  "state": "AB",
  "zip_code": "T2C 2J3",
  "country": "Canada",
  "lat": "50.99955798722045",
  "lng": "-113.98223647339631",
  "phone_number": "4034313130",
  "website": "http://www.mechaniclick.com/mechanigo/",
  "fax_number": null,
  "id":"603daaf4843cd90b4b142c53"
  },
  {
  "name": "KP Auto Repair Ltd.",
  "address": "13443 72 Ave",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 2N7",
  "country": "Canada",
  "lat": "49.13394396780947",
  "lng": "-122.8500775314537",
  "phone_number": "6045039308",
  "website": "http://www.mechaniclick.com/kpauto/",
  "fax_number": null,
  "id":"60ba509ae032b20b8ac9ae9e"
  },
  {
  "name": "Supertech",
  "address": "894 Marine Dr",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7P 1R9",
  "country": "Canada",
  "lat": "49.322661",
  "lng": "-123.097812",
  "phone_number": "6049809801",
  "website": "http://www.mechaniclick.com/supertech/",
  "fax_number": null,
  "id":"5f05f92188b7ae6323ea9157"
  },
  {
  "name": "Westcoast Auto Repairs",
  "address": "3810 E 1st Ave #5",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5C 3W1",
  "country": "Canada",
  "lat": "49.269093",
  "lng": "-123.020801",
  "phone_number": "6042511936",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/westcoast/",
  "id":"5f10faa488b7ae6323ea9160"
  },
  {
  "name": "Onyx Automotive",
  "address": "7257 King George Blvd.",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 5A7",
  "country": "Canada",
  "lat": "49.134619",
  "lng": "-122.845933",
  "phone_number": "6045032292",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/onyx/",
  "id":"5f44003d45059975fad034a1"
  },
  {
  "name": "Napa Autopro - Soares",
  "address": "1283 E Hastings St",
  "city": "Vancouver",
  "state": "BC",
  "zip_code": "V6A 1S4",
  "country": "Canada",
  "lat": "49.281644",
  "lng": "-123.077743",
  "phone_number": "6042533355",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/soares/",
  "id":"5f0e4d6288b7ae6323ea915a"
  },
  {
  "name": "Minit-Tune & Brake - Surrey",
  "address": "8832 120 St",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3V 4B4",
  "country": "Canada",
  "lat": "49.163809",
  "lng": "-122.890019",
  "phone_number": "6045918884",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/MinitSurrey/",
  "id":"5f98b6c10084470b7b370726"
  },
  {
  "name": "Burnaby Transmission",
  "address": "4555 Dawson St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5C 5T8",
  "country": "Canada",
  "lat": "49.264683",
  "lng": "-123.002320",
  "phone_number": "6042946841",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/btrans/",
  "id":"5f3ac38888b7ae6323ea9172"
  },
  {
  "name": "Mister Transmission - Surrey",
  "address": "13704 104 Ave",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3T 1W4",
  "country": "Canada",
  "lat": "49.191318",
  "lng": "-122.842397",
  "phone_number": "7787350859",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/mrts/",
  "id":"5f5000802ad0e70b855a42fb"
  },
  {
  "name": "CarCraft Auto Repair",
  "address": "15370 Fraser Hwy",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3R 3P5",
  "country": "Canada",
  "lat": "49.164054",
  "lng": "-122.796703",
  "phone_number": "6045033959",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/carcraft/",
  "id":"5f72805b3b3286595e6cab64"
  },
  {
  "name": "Bert's Automotive Transmissions",
  "address": "13391 King George Blvd",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3T 2T5",
  "country": "Canada",
  "lat": "49.203072",
  "lng": "-122.851105",
  "phone_number": "6045849151",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/berts/",
  "id":"5f4fe9662ad0e70b855a42f8"
  },
  {
  "name": "Tire Man",
  "address": "10997 River Road",
  "city": "Delta",
  "state": "BC",
  "zip_code": "V4C 2S3",
  "country": "Canada",
  "lat": "49.169055794147404",
  "lng": "-122.91535447401661",
  "phone_number": "6049518473",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/tireman/",
  "id":"6142e33d1a9c240b8820e2ab"
  },
  {
  "name": "Leah's Automotive",
  "address": "1107 West 14th Street",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7P 1J9",
  "country": "Canada",
  "lat": "49.320919",
  "lng": "-123.105559",
  "phone_number": "6049854840",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/leahs/",
  "id":"5f7363403b3286595e6cab6a"
  },
  {
  "name": "Newton Transmission and Auto Repairs",
  "address": "13308 76 Ave, V3W 2W1",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 2W1",
  "country": "Canada",
  "lat": "49.140578",
  "lng": "-122.853795",
  "phone_number": "6045973766",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/newtontrans/",
  "id":"5f98ab050084470b7b370723"
  },
  {
  "name": "Spike Auto",
  "address": "120-13571 Verdun Pl",
  "city": "Richmond",
  "state": "BC",
  "zip_code": "V6V 1Y1",
  "country": "Canada",
  "lat": "49.193500",
  "lng": "-123.073898",
  "phone_number": "6042471000",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/spike/",
  "id":"5fb459680084470b7b370733"
  },
  {
  "name": "Gord's Auto Repair",
  "address": "1520 Clark Dr",
  "city": "Vancouver",
  "state": "BC",
  "zip_code": "V5L 3L3",
  "country": "Canada",
  "lat": "49.271276",
  "lng": "-123.077004",
  "phone_number": "6048751525",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/gords/",
  "id":"5f0f52da88b7ae6323ea915d"
  },
  {
  "name": "JP Transmissions",
  "address": "8951 152 St",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3R 4E5",
  "country": "Canada",
  "lat": "49.165534",
  "lng": "-122.801878",
  "phone_number": "6045891217",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/jptrans/",
  "id":"5f72412b3b3286595e6cab61"
  },
  {
  "name": "German Auto Sports",
  "address": "13431 72 Ave",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 2N7",
  "country": "Canada",
  "lat": "49.133864",
  "lng": "-122.850457",
  "phone_number": "7785653427",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/gas/",
  "id":"5f3abc7888b7ae6323ea916c"
  },
  {
  "name": "Expo Auto Repairs",
  "address": "#05 6468 King George Blvd",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 4Z3",
  "country": "Canada",
  "lat": "49.120189",
  "lng": "-122.844567",
  "phone_number": "6049616884",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/expo/",
  "id":"5f4402a245059975fad034a4"
  },
  {
  "name": "Autotek",
  "address": "16099 Fraser Hwy",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V4N 0G2",
  "country": "Canada",
  "lat": "49.156948",
  "lng": "-122.775756",
  "phone_number": "6047160017",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/autotek/",
  "id":"5f46c9a9b4f75b0b64f418d2"
  },
  {
  "name": "A & C Automotive",
  "address": "5412 Imperial St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 1E6",
  "country": "Canada",
  "lat": "49.221771",
  "lng": "-122.985870",
  "phone_number": "6044384711",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/acauto/",
  "id":"5f7cc6c6861bf50b5be5a638"
  },
  {
  "name": "Mo's Garage",
  "address": "3855 Douglas Rd #2",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5G 3P8",
  "country": "Canada",
  "lat": "49.249861",
  "lng": "-122.981247",
  "phone_number": "6046876646",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/mo/",
  "id":"5f46bfc7b4f75b0b64f418cf"
  },
  {
  "name": "Sall Auto Service",
  "address": "5120 Imperial St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 1E2",
  "country": "Canada",
  "lat": "49.221764",
  "lng": "-122.989993",
  "phone_number": "6044352077",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/sall/",
  "id":"5f7ccb0a861bf50b5be5a63b"
  },
  {
  "name": "Imperial Street Auto Repair",
  "address": "5186 Imperial St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 1E3",
  "country": "Canada",
  "lat": "49.221722",
  "lng": "-122.989177",
  "phone_number": "6044341120",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/imperialst/",
  "id":"5f7cda6a861bf50b5be5a63e"
  },
  {
  "name": "Bond Mechanical",
  "address": "6857 Palm Ave",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 4M1",
  "country": "Canada",
  "lat": "49.221241",
  "lng": "-122.987240",
  "phone_number": "6048720641",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/bondmech/",
  "id":"5f85694f5447d70b72005c5f"
},
{
"name": "GreatYear Automotive",
"address": "325A 12th St ",
"city": "New Westminster",
"state": "BC",
"zip_code": "V3M 4H5",
"country": "Canada",
"lat": "49.203975",
"lng": "-122.925398",
"phone_number": "6042910462",
"fax_number": null,
"website": "http://www.mechaniclick.com/greatyear/",
"id": "5f8e0ffb5447d70b72005c7c"
},
{
"name": "Pemberton Auto Services",
"address": "1110 15th St W",
"city": "North Vancouver",
"state": "BC",
"zip_code": "V7P 1M9",
"country": "Canada",
"lat": "49.322366",
"lng": "-123.105244",
"phone_number": "6049870022",
"fax_number": null,
"website": "http://www.mechaniclick.com/pemberton/",
"id":"5f8ea5805447d70b72005ca2"
},
{
"name": "Minit-Tune & Brake - Burnaby - Canada Way",
"address": "3807 Canada Way",
"city": "Burnaby",
"state": "BC",
"zip_code": "V5G 1G6",
"country": "Canada",
"lat": "49.254908",
"lng": "-123.018870",
"phone_number": "6044362247",
"fax_number": null,
"website": "http://www.mechaniclick.com/minitburnaby/",
"id":"5f8e1b0f5447d70b72005c93"
},
{
"name": "Mister Transmission - Maple Ridge",
"address": "20214 Lougheed Hwy 5",
"city": "Maple Ridge",
"state": "BC",
"zip_code": "V2X 9V2",
"country": "Canada",
"lat": "49.219942",
"lng": "-122.661726",
"phone_number": "6042451246",
"fax_number": null,
"website": "http://www.mechaniclick.com/mrtransmr/",
"id":"5f8e131d5447d70b72005c7f"
},
{
"name": "Walnut Grove Auto Tech",
"address": "20092 93a Ave 1",
"city": "Langley City",
"state": "BC",
"zip_code": "V1M 3Y4",
"country": "Canada",
"lat": "49.171850",
"lng": "-122.665371",
"phone_number": "6048881617",
"fax_number": null,
"website": "http://www.mechaniclick.com/walnut/",
"id":"5f8e2a085447d70b72005c98"
},
  {
  "name": "Bill & Walter's Garage",
  "address": "4406 Dawson St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5C 4B9",
  "country": "Canada",
  "lat": "49.264380",
  "lng": "-123.005754",
  "phone_number": "6042983031",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/billandwalter/",
  "id":"5e595abe5f786369a72bfd3f"
  },
  {
  "name": "Arcadia Tranmission & Auto Repairs",
  "address": "12750 King George Blvd",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3V 3K5",
  "country": "Canada",
  "lat": "49.205944",
  "lng": "-122.868828",
  "phone_number": "6045895253",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/arcadia/",
  "id":"5f3abec988b7ae6323ea916f"
  },
  {
  "name": "Centennial Auto Body Shop Ltd",
  "address": "262 Esplanade E #4",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7L 1A1",
  "country": "Canada",
  "lat": "49.308898",
  "lng": "-123.073920",
  "phone_number": "6049808200",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/centennial/",
  "id":"5f7281b63b3286595e6cab67"
  },
  {
  "name": "Barry's Discount Auto",
  "address": "235 Pemberton Ave",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7P 2R4",
  "country": "Canada",
  "lat": "49.319819",
  "lng": "-123.108354",
  "phone_number": "6049844334",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/barry/",
  "id":"5f8e15d65447d70b72005c89"
  },
  {
  "name": "Kartek Automotive Services",
  "address": "3812 Main St",
  "city": "Vancouver",
  "state": "BC",
  "zip_code": "V5V 3N9",
  "country": "Canada",
  "lat": "49.250902",
  "lng": "-123.100661",
  "phone_number": "6048731715",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/kartek/",
  "id":"5f3ed57b88b7ae6323ea9181"
  },
  {
  "name": "Autozone Diagnostics",
  "address": " 6460 King George Blvd",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 4Z3",
  "country": "Canada",
  "lat": "49.120173",
  "lng": "-122.845041",
  "phone_number": "6045978155",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/autozone/",
  "id":"5f40103d88b7ae6323ea9187"
  },
  {
  "name": "Genesis Auto Repair",
  "address": "13433 King George Blvd",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3T 2T8",
  "country": "Canada",
  "lat": "49.202335",
  "lng": "-122.849377",
  "phone_number": "6044358543",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/genesis/",
  "id":"5f497a7e2ad0e70b855a42f2"
  },
  {
  "name": "M & N Auto Repairs Ltd.",
  "address": "530 E Broadway",
  "city": "Vancouver",
  "state": "BC",
  "zip_code": "V5T 1X5",
  "country": "Canada",
  "lat": "49.262320",
  "lng": "-123.092330",
  "phone_number": "6048722211",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/mandn/",
  "id":"5f3ac38888b7ae6323ea9172"
  },
  {
  "name": "International Auto Service",
  "address": "Unit E 335 North Rd",
  "city": "Coquitlam",
  "state": "BC",
  "zip_code": "V3K 3V8",
  "country": "Canada",
  "lat": "49.244526, ",
  "lng": "-122.892309",
  "phone_number": "6049363318",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/international/",
  "id":"5f4fc6c12ad0e70b855a42f5"
  },
  {
  "name": "HTV Auto Body",
  "address": "5368 Lane St",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5H 2H5",
  "country": "Canada",
  "lat": "49.222208",
  "lng": "-122.986389",
  "phone_number": "6045680063",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/htv/",
  "id":"5f7f53c1861bf50b5be5a655"
  },
  {
  "name": "AFS Automotive",
  "address": "7438 Gilley Ave, Burnaby",
  "city": "Burnaby",
  "state": "BC",
  "zip_code": "V5J 4X5",
  "country": "Canada",
  "lat": "49.216251",
  "lng": "-122.971513",
  "phone_number": "6044319910",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/afs/",
  "id":"5f7dcdde861bf50b5be5a64f"
  },
  {
  "name": "Save Max Auto Repair",
  "address": "10509 135a St",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3T 4C9",
  "country": "Canada",
  "lat": "49.193624",
  "lng": "-122.847287",
  "phone_number": "6045807850",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/savemax/",
  "id":"5f3afd3988b7ae6323ea9178"
  },
  {
  "name": "Jas Auto Repairs Ltd.",
  "address": "#16A - 7823 - 123nd Street",
  "city": "Surrey",
  "state": "BC",
  "zip_code": "V3W 4M8",
  "country": "Canada",
  "lat": "49.144994",
  "lng": "-122.857705",
  "phone_number": "604597466",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/jas/",
  "id":"5f34370388b7ae6323ea9169"
  },
  {
  "name": "Formula Automotive",
  "address": "104-1300 Lougheed Hwy",
  "city": "Coquitlam",
  "state": "BC",
  "zip_code": "V3K 6S4",
  "country": "Canada",
  "lat": "49.232875",
  "lng": "-122.856401",
  "phone_number": "6045206302",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/formula/",
  "id":"5f4955142ad0e70b855a42ef"
  },
  {
  "name": "Everbloom Auto Repairs",
  "address": "1606 Clark Dr",
  "city": "Vancouver",
  "state": "BC",
  "zip_code": "V5L 4Y2",
  "country": "Canada",
  "lat": "49.270426",
  "lng": "-123.077157",
  "phone_number": "6042512431",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/everbloom/",
  "id":"5f23306788b7ae6323ea9166"
  },
  {
  "name": "Power Tune",
  "address": "236 MacKay Rd",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7P 3H4",
  "country": "Canada",
  "lat": "49.319745",
  "lng": "-123.102065",
  "phone_number": "6049866777",
  "fax_number": null,
  "website": "http://www.mechaniclick.com/powertune/",
  "id":"5ee2a504fda81a43f8d9bc5d"
  },
  {
  "name": "TestEnv",
  "address": "2369876 MacKay Rd",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7P 3H4",
  "country": "Canada",
  "lat": "49.312745",
  "lng": "-123.104065",
  "phone_number": "6049866777",
  "fax_number": null,
  "website": "/UserCreate",
  "id":"5e595abe5f786369a72bfd3f"
  },
  {
  "name": "TestEnvLocal",
  "address": "2369876 MacKay Rd",
  "city": "North Vancouver",
  "state": "BC",
  "zip_code": "V7P 3H4",
  "country": "Canada",
  "lat": "49.312745",
  "lng": "-123.104065",
  "phone_number": "6049866777",
  "fax_number": null,
  "website": "/UserCreate",
  "id":"620bf9dc833e68a1dc6b6231"
  },
  ]



// WEBPACK FOOTER //
// ./src/data/serviceCenters.js